import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { StyledTableRow } from "../../../Utils/styledcell";

export default function PayoutsTable({ rows, isMobile, formatAmount }) {
  /* -------------------------------------------------- MOBILE  */
  if (isMobile) {
    return (
      <Box sx={{ display: "grid", gap: 2 }}>
        {rows.map((p) => (
          <Card
            key={p.payout_id || "N/A"}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              transition: "transform .3s",
              "&:hover": { transform: "translateY(-3px)" },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  @{p.creator_id}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {new Date(p.payout_date).toLocaleDateString()}
                </Typography>
              </Box>

              <Typography variant="body2" color="text.secondary">
                {p.campaignname || "Creator Payout"} •{" "}
                {p.blitzpay ? "BlitzPay" : "Standard"}
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                <Typography variant="body1" fontWeight={500}>
                  {formatAmount(p.amount)}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color:
                      p.status === "pending"
                        ? "#ed6c02"
                        : p.status === "paid"
                        ? "#2e7d32"
                        : "#9e9e9e",
                  }}
                >
                  {p.status}
                </Typography>
              </Box>

              {p.notes && (
                <Typography
                  variant="body2"
                  sx={{ mt: 1, fontStyle: "italic", whiteSpace: "pre-wrap" }}
                >
                  {p.notes}
                </Typography>
              )}
            </CardContent>
          </Card>
        ))}
      </Box>
    );
  }

  /* -------------------------------------------------- DESKTOP TABLE */
  return (
    <Table aria-label="payouts table">
      <TableHead>
        <TableRow>
          {[
            "Creator ID",
            "Campaign",
            "Payout Date",
            "Status",
            "BlitzPay",
            "Amount",
            "Notes",
          ].map((h) => (
            <TableCell key={h}>{h}</TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((p) => (
          <StyledTableRow key={p.payout_id || "N/A"}>
            <TableCell>@{p.creator_id}</TableCell>
            <TableCell>{p.campaignname || "Creator Payout"}</TableCell>
            <TableCell>{new Date(p.payout_date).toLocaleDateString()}</TableCell>
            <TableCell>{p.status}</TableCell>
            <TableCell>{p.blitzpay ? "true" : "false"}</TableCell>
            <TableCell>{formatAmount(p.amount)}</TableCell>
            <TableCell>{p.notes}</TableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  );
}
